// extracted by mini-css-extract-plugin
export default {"previewBanner":"PreviewBanner_previewBanner__VbeIf"};